//此文件由工具自动生成,不要手动修改此文件
//在/centralsvn/BaseCode/wpcommonEditors/User.xlsm中修改并生成
//update_time[2022.6.13 10:15:57]

let userTableType = {};

userTableType.getData = function() {
	var data = [
		{
			value : 1,
			file : "TbUserSchema",
			name : "tb_user",
			define : "用户主表",
		},
		{
			value : 2,
			file : "TbEventSchema",
			name : "tb_event",
			define : "用户事件表",
		},
		{
			value : 3,
			file : "TbOrderSchema",
			name : "tb_order",
			define : "用户订单表",
		},
		{
			value : 4,
			file : "TbFormSchema",
			name : "tb_form",
			define : "用户提交问卷表单",
		},
		{
			value : 5,
			file : "TbCouponsSchema",
			name : "tb_user_coupons",
			define : "会员优惠券",
		},
		{
			value : 6,
			file : "TbCartSchema",
			name : "tb_cart",
			define : "购物车",
		},
		{
			value : 7,
			file : "TbPointSchema",
			name : "tb_point",
			define : "会员积分获取表",
		},
		{
			value : 8,
			file : "TbFavoriteSchema",
			name : "tb_user_favorite",
			define : "用户收藏夹",
		},
		{
			value : 9,
			file : "TbBrowsehistorySchema",
			name : "tb_browsehistory",
			define : "用户浏览记录",
		},
		{
			value : 10,
			file : "TbCardSchema",
			name : "tb_user_card",
			define : "会员卡",
		},
		{
			value : 11,
			file : "TbAddressSchema",
			name : "tb_user_address",
			define : "用户地址",
		},
		{
			value : 12,
			file : "TbShowSchema",
			name : "tb_buyer_show",
			define : "买家秀",
		},
		{
			value : 13,
			file : "TbMessageSchema",
			name : "tb_user_message",
			define : "用户站内信",
		},
		{
			value : 14,
			file : "TbChatlogSchema",
			name : "tb_user_chatlog",
			define : "用户聊天记录",
		},
		{
			value : 15,
			file : "TbMarketingSchema",
			name : "tb_user_marketing",
			define : "业务员信息表",
		},
		{
			value : 16,
			file : "TbOrderDetailSchema",
			name : "tb_order_detail",
			define : "订单商品详情",
		},
		{
			value : 17,
			file : "TbOrderHistorySchema",
			name : "tb_order_history",
			define : "订单修改历史记录",
		},
		{
			value : 18,
			file : "TbActivitySchema",
			name : "tb_activity",
			define : "用户参加活动记录",
		},
		{
			value : 19,
			file : "TbRewardSchema",
			name : "tb_reward",
			define : "活动奖励发放记录",
		},
		{
			value : 20,
			file : "TbAfterServiceSchema",
			name : "tb_after_service",
			define : "售后服务",
		},
		{
			value : 21,
			file : "TbOrderPackageSchema",
			name : "tb_order_package",
			define : "订单打包发货管理",
		},
		{
			value : 22,
			file : "TbShowCommentSchema",
			name : "tb_buyer_comment",
			define : "买家秀的评论",
		},
		{
			value : 23,
			file : "TmpDatasourceResSchema",
			name : "tmp_datasource_res",
			define : "数据源运算结果",
		},
		{
			value : 24,
			file : "TbPolicySchema",
			name : "tb_policy",
			define : "使用协议隐私条款等授权",
		},
		{
			value : 25,
			file : "TbLoginHistorySchema",
			name : "tb_loginhistory",
			define : "登录履历",
		},
		{
			value : 26,
			file : "TbSubscribeMessageSchema",
			name : "tb_subscribe_message",
			define : "订阅消息",
		},
		{
			value : 27,
			file : "TbPointConsumeSchema",
			name : "tb_point_consume",
			define : "积分消费表",
		},
		{
			value : 28,
			file : "TbSubscribeArticleSchema",
			name : "tb_subscribe_article",
			define : "订阅收藏文章",
		},
		{
			value : 29,
			file : "TbMessageCommentSchema",
			name : "tb_message_comment",
			define : "留言板评论",
		},
		{
			value : 30,
			file : "TbMgmInviteCodeSchema",
			name : "tb_mgm_invite_code",
			define : "MGM邀请码",
		},
	];
	return data;
};

export default userTableType;



// WEBPACK FOOTER //
// ./src/utils/UserTableType.js